__turbopack_context__.v({
  "caption": "ArticleFigure-module__ls263G__caption",
  "figure": "ArticleFigure-module__ls263G__figure",
  "figureCenter": "ArticleFigure-module__ls263G__figureCenter",
  "figureFull": "ArticleFigure-module__ls263G__figureFull",
  "media": "ArticleFigure-module__ls263G__media",
});
